import { NgModule } from '@angular/core';
import { SearchBusinessPipe } from './search-business.service';

@NgModule({
  declarations: [
    SearchBusinessPipe,
  ],
  exports: [
    SearchBusinessPipe,
  ]
})

export class PipesModule { }
